<div class="footer bg-dark d-print-none">
  <footer class="pt-3 pb-2 align-self-end container">
    <h4 class="text-white text-center pb-3"><strong>WHERE TO FIND US</strong></h4>
    <div class="row g-0 mb-5">
      <div class="col-12 d-none d-lg-block">
        <div class="row text-center">
          <div class="col mx-md-3 p-0 card border-light bg-dark">
            <div class="card-img-top">
              <img src="assets/images/support_icon.png" width="100" alt=""/>
            </div>
            <div class="card-body pt-0">
              <h4 class="card-text">
                <u><a href="https://it.utah.edu/help/index.php">CAMPUS SUPPORT</a></u>
              </h4>
              <p class="card-text">
                <a href="tel:801-581-4000">801.581.4000 x 1</a>
              </p>
            </div>
          </div>
          <div class="col mx-md-3 p-0 card border-light bg-dark">
            <div class="card-img-top">
              <img src="assets/images/knowledge_icon.png" width="100" alt=""/>
            </div>
            <div class="card-body pt-0">
              <h4 class="card-text">
                <u><a href="https://lib.utah.edu/services/knowledge-commons/">KNOWLEDGE COMMONS</a></u>
              </h4>
              <p class="card-text">
                Marriott Library (level 2)<br>
                295 S 1500 E<br>
                Salt Lake City, UT 84112<br>
                <a href="tel:801-581-6273">801.581.6273</a>
              </p>
            </div>
          </div>
          <div class="col mx-md-3 p-0 card border-light bg-dark">
            <div class="card-img-top">
              <img src="assets/images/hospital-icon.png" width="100" alt=""/>
            </div>
            <div class="card-body pt-0">
              <h4 class="card-text">
                <u><a href="mailto:servicedesk@hsc.utah.edu">U HEALTH SUPPORT</a></u>
              </h4>
              <p class="card-text">
                <a href="tel:801-587-6000">801.587.6000</a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 d-xs-block d-lg-none">
        <div class="text-center">
          <div class="card col-xs-12 mb-4 border-light bg-dark">
            <div class="card-img-top">
              <img src="assets/images/support_icon.png" width="100" alt=""/>
            </div>
            <div class="card-body pt-0">
              <h4 class="card-text">
                <u>CAMPUS SUPPORT</u>
              </h4>
              <p class="card-text">
                <a href="tel:801-581-4000">801.581.4000 x 1</a>
              </p>
            </div>
          </div>
          <div class="card col-xs-12 mb-4 border-light bg-dark">
            <div class="card-img-top">
              <img src="assets/images/knowledge_icon.png" width="100" alt=""/>
            </div>
            <div class="card-body pt-0">
              <h4 class="card-text">
                <u><a href="https://lib.utah.edu/services/knowledge-commons/">KNOWLEDGE COMMONS</a></u>
              </h4>
              <p class="card-text">
                Marriott Library (level 2)<br>
                295 S 1500 E<br>
                Salt Lake City, UT 84112<br>
                <a href="tel:801-581-6273">801.581.6273</a>
              </p>
            </div>
          </div>
          <div class="card col-xs-12 mb-4 border-light bg-dark">
            <div class="card-img-top">
              <img src="assets/images/hospital-icon.png" width="100" alt=""/>
            </div>
            <div class="card-body pt-0">
              <h4 class="card-text">
                <u><a href="mailto:servicedesk@hsc.utah.edu">U HEALTH SUPPORT</a></u>
              </h4>
              <p class="card-text">
                <a href="tel:801-587-6000">801.587.6000</a>
              </p>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="row small text-white">
      <div class="row col-lg-5 mb-4">
        <div class="col-sm-6 col-lg-4">
          <p class="footer-contact">
            Stay In Touch
          </p>
          <hr>
          <p class="footer-contact-link">
            <a href="http://software.utah.edu/contact.php">
              Find Us
            </a>
          </p>
          <p class="footer-contact-link">
            <a href="mailto:software@utah.edu?subject=">
              Contact OSL
            </a>
          </p>
        </div>
        <div class="col-sm-6 col-lg-6 offset-lg-2">
          <p class="footer-contact">
            Fine Print
          </p>
          <hr>
          <p class="footer-contact-link">
            <a href="http://www.utah.edu/disclaimer/">
              Disclaimer
            </a>
          </p>
          <p class="footer-contact-link">
            <a href="http://www.utah.edu/privacy/">
              Privacy
            </a>
          </p>
          <p class="footer-contact-link">
            <a href="https://www.utah.edu/nondiscrimination/">
              Non-Discrimination &<br>
              Accessibility
            </a>
          </p>
        </div>
      </div>
      <div class="col-lg-4 offset-lg-3">
        <a href="https://imagineu.utah.edu" target="_blank">
          <img src="assets/images/imagine_u.png" class="imagine img-fluid" alt="Imagine U"/>
        </a>
        <div class="d-flex">
          <a href="https://cis.utah.edu">
            <img src="assets/images/icon-cis.png" class="pt-2" alt="CIS" width="50px"/>
          </a>
          <a href="https://www.umail.utah.edu">
            <img src="assets/images/icon-umail.png" class="pt-2" alt="UMail" width="50px"/>
          </a>
          <a class="pt-2 ps-2 pe-2" href="https://www.facebook.com/universityofutah">
            <app-social-media-icon [platform]="'facebook'" [size]="2"></app-social-media-icon>
          </a>
          <a class="pt-2 ps-2 pe-2" href="https://www.twitter.com/uutah">
            <app-social-media-icon [platform]="'twitter'" [size]="2"></app-social-media-icon>
          </a>
          <a class="pt-2 ps-2 pe-2" href="https://www.youtube.com/theuniversityofutah">
            <app-social-media-icon [platform]="'youtube'" [size]="2"></app-social-media-icon>
          </a>
          <a class="pt-2 ps-2 pe-2" href="https://www.instagram.com/universityofutah">
            <app-social-media-icon [platform]="'instagram'" [size]="2"></app-social-media-icon>
          </a>
        </div>
        <p class="footer-contact">
          <a href="https://software.utah.edu">Office of Software Licensing (OSL)</a><br>
          Eccles Broadcast Center<br>
          101 Wasatch Dr Rm 215<br>
          Salt Lake City, UT 84112<br>
          <a href="tel:801-581-4000">Phone: 801-581-4000 X 1</a><br>
          <br>
          © The University of Utah
        </p>
      </div>
    </div>
  </footer>
</div>
